module.exports = __webpack_public_path__ + "static/media/sm_instagram.7943776b.svg";